module.exports = __webpack_public_path__ + "img/basket-shopping.d6a03045.svg";